import CurrencySymbols from '../constants/CurrencySymbols';

interface Options {
  toRound?: boolean;
}

export default function formatPrice(
  rawPrice: number,
  currency: string,
  { toRound }: Options = {},
): string {
  const currencyStr = CurrencySymbols[currency] || `${currency} `;
  const price = toRound
    ? Math.round(rawPrice / 100)
    : Math.floor(rawPrice / 100);

  return `${currencyStr}${price}`;
}
